import React from 'react';
import { useTranslation } from 'react-i18next';
import { SimpleModal } from '@livable/saas-react-components';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores';
import { ModalContent } from './modalContent/modalContent';
export const OldUtilityConfigurationModal = observer(_ref => {
  var _store$homeDashboardS;
  let isOpen = _ref.isOpen,
    handleClose = _ref.handleClose,
    utility = _ref.utility;
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(SimpleModal, {
    noFooter: true,
    noPadding: true,
    variant: "middle",
    title: t("add_new_property_flow.".concat(!!utility && utility.id !== 'NEW_UTILITY_TEMPLATE' ? 'edit_utility_template' : 'add_utility_template')),
    subTitle: (_store$homeDashboardS = store.homeDashboardStore.getCurrentProperty) === null || _store$homeDashboardS === void 0 || (_store$homeDashboardS = _store$homeDashboardS.buildingInformation) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.buildingAddress,
    trigger: null,
    isOpen: isOpen,
    handleClose: handleClose
  }, /*#__PURE__*/React.createElement(ModalContent, {
    key: utility === null || utility === void 0 ? void 0 : utility.id,
    utility: utility,
    handleClose: handleClose,
    isEditing: !!utility && utility.id !== 'NEW_UTILITY_TEMPLATE'
  }));
});